<template>
    <div class="login-container">
        <div class="content">
            <div class="containerTop">
                <img :src="imgUrl.itsmlogo" alt="" srcset="">
            </div>
            <div class="containerContentB">

                <div class="containerContentB_R">
                    <div>
                        <div class="containerContentB_R_t">
                            <div :class='ind === 0 ? "active" : "" ' @click='WLogin(0)'>飞书登录<em/></div>
                             <div :class='ind === 1 ? "active" : "" ' @click='WLogin(1)'>智联账号登录<em/></div>

                             <div :class='ind === 2 ? "active" : "" ' @click='WLogin(2)'>第三方登录<em/></div>

                        </div>
                        <div class="containerContentB_R_b">
                            <div class='containerContentB_R_b_f' v-if='ind === 1'>
                                <loginForm v-if='title==="login"' @changetitle='changetitle' :ind="ind" />
                                <forgetForm v-if='title==="forget"' @changetitle='changetitle'/>
                                <registerForm v-if='title==="register"' @changetitle='changetitle'/>
                            </div>
                            <div class='containerContentB_R_b_f2' v-if='ind === 2'>
                                <loginForm v-if='title==="login"' @changetitle='changetitle' :ind="ind"/>
                                <forgetForm v-if='title==="forget"' @changetitle='changetitle'/>
                                <registerForm v-if='title==="register"' @changetitle='changetitle'/>
                            </div>
                            <div v-show='ind===0' class='we_box'>
                                <div class="loginForm_slogan">
                                    <span>欢迎使用  ITSM管控平台</span>
                                </div>
                                <div class="feishuBtn" @click="loginEvent">
                                    <img src="../../assets/feishu.png" class="logoimg">
                                    <span style="font-size:18px;">登录</span>
                                </div>
                                <!-- <div>
                                    <img class='we_box_img' :src="imgUrl.tips" alt="">
                                    <div>
                                        <img :src="imgUrl.Shape" alt="">
                                        <span>仅支持 四维智联 员工企业微信扫码登录！</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { isvalidUsername } from '../../core/utils/validate'
import ssoService from '../../services/sso.service.js'
import forgetForm from './forgetForm'
import loginForm from './loginForm'
import registerForm from './registerForm'



export default {
    name: 'login',
    components: {
        forgetForm,
        loginForm,
        registerForm
    },
    mounted () {

    },

    data: function () {
        return {
            imgUrl: {
                banner: require('../../assets/banner.png'),
                itsmlogo: require('../../assets/itsmlogo.png'),
                tips: require('../../assets/tips.png'),
                Shape: require('../../assets/Shape.png')
            },
            feishuUrl:{
                beta:'https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=http%3A%2F%2Fwedof-sso-beta.autoai.com%2Fusercenter%2Fsso%2Ffeishu%2Fv1%2Faccess%2Fcallback&app_id=cli_a2d9506bb958d00e',
                prod:'https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=https%3A%2F%2Fwedof-sso.autoai.com%2Fusercenter%2Fsso%2Ffeishu%2Fv1%2Faccess%2Fcallback&app_id=cli_a2d9506bb958d00e'
            },
            ind: 0,
            title: 'login',
        }
    },

    methods: {
        loginEvent(){
            // console.log(process.env.NODE_ENV)
            let goUrl = ''
            if(process.env.NODE_ENV !== 'production'){
                goUrl = this.feishuUrl.beta
            }else{
                goUrl = this.feishuUrl.prod
            }
            window.location.href = goUrl + '&state=itsm'

        },
        WLogin(index) {
            this.ind = index
            this.title = 'login'
        },
        changetitle(title) {
            this.title = title
        },
        async init() {
            let err, logined, userinfo;
            [err, logined] = await common.to(ssoService.logined({userName: this.$cookies.get('user_name')}));
            if(err) {
                this.$message.error(err.message);
                console.log(err)
                return
            }
            [err, userinfo] = await common.to(ssoService.setUserInfo());
            if(userinfo && userinfo.user_data){
                this.$store.commit('setUserInfo', {user: {...userinfo, ...logined.user}});
                window.localStorage.setItem('userid', logined.user.username);
                window.localStorage.setItem('wedof_itsm_web_user_name', userinfo.userid)
                for (let i in userinfo) {
                    window.localStorage.setItem(i, userinfo[i]);
                }

                window.sessionStorage.setItem('routerLink', location.href);
                // this.$router.push('/')
                return;
            }
            if(err) {
                this.$message.error(err.message);
                return;
            };


        }
    }
}

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .login-container {
        width: 100%;
        height: 100%;
        // overflow: hidden;
        // background: url('../../assets/bgimg.png') 100% 100% no-repeat;
        background: url('../../assets/itsmbgimg.jpg') 100% 100% no-repeat;
        background-size: 100% 100%;
        #wx_qrcode{
            width:100%;
            text-align: center;
        }
        .backTitle{
            cursor: pointer;
            font-size:20px !important;
            margin: 10px 20px;
            color:#939599;
        }
        .content {
            width: 100%;
            height: 100%;
            .containerTop {
                margin-top:30px;
                margin-left:60px;
                margin-bottom:30px;
                img {
                    width: 425px;
                    height: 30px;
                }
            }
            .containerContentB {
                display: flex;
                justify-content: center;
                align-items: center;
                -height: 80%;
                height:550px;
                .containerContentB_L {
                    padding: 20px;
                    width: 920px;
                    background: #ffffff;
                    border-radius: 6px;
                    .containerContentB_L_t {
                        font-size: 16px;
                        line-height: 22px;
                        color: #3C3C3C;
                        padding: 20px;
                        background: #F2F8FF;
                        border-radius: 5px;
                    }
                    img {
                        width: 852px;
                        height: 576px;
                        display: block;
                    }
                }
                .containerContentB_R {
                    margin-left:80px;
                    width: 600px;
                    height:100%;
                    background: #ffffff;
                    border-radius: 6px;
                    .containerContentB_R_t {
                        width: 100%;
                        height: 80px;
                        display: flex;
                        border-bottom: 1px solid #ccc;
                        border-radius: 6px 6px 0 0;
                        div {
                            cursor: pointer;
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 20px;
                            font-weight: 800;
                            position: relative;
                            &:nth-child(1) {
                                border-radius: 6px 0 0 0;
                                border-right: 1px solid #ccc;
                            }
                            &:nth-child(2) {
                                border-radius: 0 6px 0 0;
                                border-right: 1px solid #ccc;
                                img {
                                    vertical-align: middle;
                                    margin-right: 5px;
                                }
                            }
                            em {
                                transition: 0.5s;
                                position: absolute;
                                bottom: -1px;
                                left: 50%;
                                transform: translate(-50%);
                                width: 0;
                                height: 4px;
                                background: #3A8DFC ;
                            }
                        }
                        div.active {
                            color: #3A8DFC;
                            em {
                                width: 100%;
                            }
                        }
                    }
                    .containerContentB_R_b {
                        /*display: flex;*/
                        /*flex-direction: column;*/
                        .containerContentB_R_b_f {
                             /deep/ input {
                                 border-radius: 0;
                                 border-top: none;
                                 border-left: none;
                                 border-right: none;
                             }
                         }
                        .containerContentB_R_b_f2 {
                            /deep/ input {
                                border-radius: 0;
                                border-top: none;
                                border-left: none;
                                border-right: none;
                            }
                        }
                        .we_box {
                            position: relative;
                            margin-top:50px;
                            .feishuBtn{
                                margin:150px auto;
                                width:70%;
                                height:40px;
                                line-height: 40px;
                                text-align: center;
                                border-radius:5px;
                                border:1px solid #c0c0c0;
                                cursor: pointer;
                                background:#1890ff;
                                color:#fff;
                                .logoimg{
                                    vertical-align: text-bottom;
                                    width: 25px;
                                    height: auto;
                                    margin-right: 7px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1500px) {
        .login-container {
            display: flex;
            // align-items: center;
            // justify-content: center;
            .content {
                .containerTop {
                    // display: flex;
                    // align-items: center;
                    // justify-content: center;
                    // display:none;
                }
                .containerContentB {

                    justify-content: center;
                    align-items: center;
                    .containerContentB_L {
                        display:none;
                    }
                    .containerContentB_R {

                        .containerContentB_R_b {
                            .containerContentB_R_b_f {

                            }
                            #wx_qrcode {
                                /deep/ iframe {

                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (min-width: 1500px) {}
</style>

